import { render, staticRenderFns } from "./TempEmailCard.vue?vue&type=template&id=74c5f9d3&scoped=true"
import script from "./TempEmailCard.vue?vue&type=script&lang=js"
export * from "./TempEmailCard.vue?vue&type=script&lang=js"
import style0 from "./TempEmailCard.vue?vue&type=style&index=0&id=74c5f9d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c5f9d3",
  null
  
)

export default component.exports